import { Link } from "react-router-dom";

const INSPECTION_LINKS = [
  { label: "Pre-Purchase Car Inspections", to: "/services/pre-purchase-inspection" },
  { label: "Why Choose Lemon Protector", to: "/about" },
  { label: "Personal Inspector Consultation", to: "/about#consultation" },
  { label: "Out-of-State Car Buyers", to: "/about#out-of-state" },
  { label: "Benefits of Car Inspections", to: "/about#benefits" },
];

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Service Areas", to: "/location/new-york" },
  { label: "FAQ", to: "/about#faq" },
  { label: "Contact Us", to: "/contact" },
  { label: "Schedule Inspection", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src="https://lemonprotector.com/images/oldsite/logo_graphic.gif"
                  alt="Lemon Protector Car Logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <img
                src="https://lemonprotector.com/images/lemonpro-logo-text-1.jpg"
                alt="Lemon Protector"
                className="h-7 object-contain"
              />
            </div>
            <p className="font-sans text-sm text-gray-500 leading-relaxed max-w-sm mb-2">
              <em className="text-gray-600 font-medium">Premier Used Car Inspections in NY, NJ, CT.</em>
            </p>
            <p className="font-sans text-sm text-gray-500 leading-relaxed max-w-sm">
              Don&apos;t buy a lemon — get a professional 450-point pre-purchase inspection before you sign. On-site service, direct inspector consultation, starting at $139.
            </p>

            <div className="mt-6 flex flex-col gap-2">
              <a
                href="tel:5169833800"
                className="flex items-center gap-2 text-brand-gold font-sans text-sm font-semibold hover:text-brand-gold-muted transition-colors"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-base" />
                </div>
                (516) 983-3800
              </a>
              <a
                href="tel:7182297594"
                className="flex items-center gap-2 text-brand-gold font-sans text-sm font-semibold hover:text-brand-gold-muted transition-colors"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-base" />
                </div>
                (718) 229-7594
              </a>
            </div>

            <div className="mt-5 flex gap-3">
              <a
                href="https://www.facebook.com/lemonprotector"
                rel="nofollow"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 hover:text-brand-gold hover:border-brand-gold transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a
                href="https://twitter.com/LemonProtector"
                rel="nofollow"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 hover:text-brand-gold hover:border-brand-gold transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-sm" />
              </a>
            </div>
          </div>

          {/* Inspection Services */}
          <div>
            <h4 className="font-serif text-gray-900 text-base font-semibold mb-5">
              <a href="/services/pre-purchase-inspection" className="hover:text-brand-gold transition-colors">
                Inspection Services
              </a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {INSPECTION_LINKS.map((s) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    className="font-sans text-sm text-gray-500 hover:text-brand-gold transition-colors flex items-center gap-2"
                  >
                    <span className="w-1 h-1 rounded-full bg-brand-gold/60 shrink-0" />
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-gray-900 text-base font-semibold mb-5">
              <a href="/" className="hover:text-brand-gold transition-colors">
                Quick Links
              </a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {QUICK_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-sans text-sm text-gray-500 hover:text-brand-gold transition-colors flex items-center gap-2"
                  >
                    <span className="w-1 h-1 rounded-full bg-brand-gold/60 shrink-0" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <a
                href="http://www.bbb.org/new-york-city/business-reviews/auto-diagnostic-service/lemon-protector-in-plainview-ny-8459/"
                rel="nofollow"
                target="_blank"
              >
                <img
                  src="https://lemonprotector.com/images/home/blue-seal-63-134-lemon-protector-8459.png"
                  alt="BBB Accredited Business — Lemon Protector"
                  className="w-16 object-contain"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-gray-50 border-t border-gray-200 px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-sans text-xs text-gray-400">
          © Lemon Protector 2013–2026. All rights reserved.
        </p>
        <p className="font-sans text-xs text-brand-gold italic font-medium">
          Don&apos;t Buy a Lemon — Check With Us First!
        </p>
      </div>
    </footer>
  );
}
